export default (state=[], action) =>{
    let query = {};
    switch(action.type){
        case 'SET_STATUS_CHECK_CHART_LINE':
            query = {
                code: action.payload.code,
                selection: {
                    filter: 'item',
                    values: action.payload.values
                }
            }
            return state.map(q => (q.code === action.payload.code ? query : q));
        case 'SET_QUERY_ALL_VALUES_CHART_LINE':
            query = {
                code: action.payload,
                selection: {
                    filter: 'all',
                    values: ["*"]
                }
            }
            return state.map(q => (q.code === action.payload ? query : q));
        default:
            return state;
    }
}
